var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReadmore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.6918,
    cy: 13.2471,
    r: 12.5,
    fill: "#DFAD17"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.1893 8.87041C10.335 8.7359 10.5713 8.7359 10.717 8.87041L15.1946 13.0036C15.3403 13.1381 15.3403 13.3562 15.1946 13.4907L10.717 17.6239C10.5713 17.7584 10.335 17.7584 10.1893 17.6239C10.0436 17.4894 10.0436 17.2713 10.1893 17.1368L14.4031 13.2471L10.1893 9.35751C10.0436 9.223 10.0436 9.00492 10.1893 8.87041Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReadmore);
export default __webpack_public_path__ + "static/media/readmore.0a16fd6b9466106fb7ab1f0d67ca9465.svg";
export { ForwardRef as ReactComponent };